import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Warning } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import { StyledIconContainer } from '../index.css'

const StyledContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.warningInfo
})`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  background-color: ${({ mode }: { mode: Theme }) => sys[mode].common.warning.background};
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
`

const WarningInfo = () => {
  const theme = useDisplayTheme() as Theme
  return (
    <StyledContainer mode={theme}>
      <StyledIconContainer>
        <Warning color={sys[theme].common.warning.default} fontSize={16} />
      </StyledIconContainer>
      WARNING: This post might contain NSFW content.
    </StyledContainer>
  )
}

export default WarningInfo
